import { useTheme } from '@mui/material';

/** The axis, grid and tooltip props shared by every chart, taken from the theme rather than hard-coded. */
export const useChartTheme = () => {
  const theme = useTheme();

  return {
    grid: { strokeDasharray: '3 3', vertical: false, stroke: theme.palette.divider },
    axis: {
      tickLine: false,
      axisLine: false,
      tick: { fill: theme.palette.text.secondary, fontSize: 12 },
    },
    tooltip: {
      cursor: { fill: theme.palette.action.hover },
      contentStyle: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 10,
        color: theme.palette.text.primary,
      },
    },
  };
};
